import { motion } from 'motion/react'
import { useEffect, useState } from 'react'

import { withPublicImageUrl } from '@lib/utils/cdn'

import { Arrow } from '../arrow/arrow'
import ConfettiExplosionCSS from '../confetti-explosion/confetti-explosion-css'

import { OnePasswordExtensionBypass } from './one-password-extension-bypass'

import style from './fake-notch.module.scss'

// delay to wait the bench to be moved to the right
const delay = 0.3

/**
 * a fake notch button to simulate the real extension notch.
 * it also contains the confetti explosion animation. and an arrow to indicate where the button is.
 * @param onClick - the function to call when the button is clicked
 * @param showNotchButton - whether to show the notch button
 * @returns
 */
export const FakeNotch = ({ onClick }: { onClick: () => void }) => {
  const [showConfettiExplosion, setShowConfettiExplosion] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowConfettiExplosion(true)
    }, delay * 1000)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <>
      <ConfettiExplosionCSS trigger={showConfettiExplosion} />
      <motion.div
        className={style.notch}
        initial={{
          opacity: 0,
          scaleX: 0.8,
          scaleY: 1.2,
          translateX: '-10%',
          translateY: '-50%',
        }}
        animate={{
          opacity: 1,
          scaleX: 1,
          scaleY: 1,
          translateX: 0,
          translateY: '-50%',
        }}
        transition={{
          duration: 0.6,
          ease: [0, 0, 0.2, 1],
          delay: 0.4,
        }}
        exit={{
          opacity: 0,
          translateX: '100%',
          translateY: '-50%',
          transition: { duration: 0.2, delay: 0 },
        }}
      >
        <button
          className={style.notchButton}
          data-superhuman-go-open
          data-superhuman-go-open-meta={JSON.stringify({
            // this source key must be supported by extension
            source: 'superhuman_go_welcome_page',
          })}
          onClick={onClick}
        >
          <span
            className={style.notchIcon}
            style={{
              backgroundImage: `url(${withPublicImageUrl('super-human-go.svg')})`,
            }}
          />
          <OnePasswordExtensionBypass />
        </button>
      </motion.div>
      <Arrow />
    </>
  )
}
